import { getEnvStr } from '../../tools/utils';

/**
 * @description 域名改造 webapps -> payment
 * // create by yangtao 2024_06_05
 */

const env:string = getEnvStr();

const DOMAIN:any = {
  dev: 'https://devpayment.yjbtest.com',
  fz: 'https://fzpayment.yjbtest.com',
  prod: 'https://payment.yongjinbao.com.cn'
};

const baseUrl = `${DOMAIN[env]}/payment/gateway`;

console.log('当前地址：：：：baseUrl', baseUrl);

export default {
  getWechatAuth: `${baseUrl}/wechat/pub/get-wx-auth-url`,
  getWechatUserInfo: `${baseUrl}/wechat/pub/get-wx-openid_v2`,
  preOrder: `${baseUrl}/unified/pre_order`,
  getSysTime: `${baseUrl}/unified/get-sys-time`
}
